module.exports = __webpack_public_path__ + "static/img/jingye.75b49c5e.png";